import { makeStyles, Theme } from '@material-ui/core/styles'
import { Alert, AlertTitle } from '@material-ui/lab'
import React from 'react'
import { useSelector } from 'react-redux'
import useSimulationFee from '../../../../hooks/useSimulationFee'
import { RootState } from '../../../../redux/store'
import { getInternationalizedValue } from '../../../../utils/common'

interface WarningText {
  title: string
  description: string
}

const useStyles = makeStyles((theme: Theme) => ({}))

const FeeFooter = () => {
  const { language } = useSelector((state: RootState) => state.app)

  const data = useSimulationFee()
  const warnings: WarningText[] = data.warning.map(d => ({
    title: getInternationalizedValue(d, 'title', language),
    description: getInternationalizedValue(d, 'description', language),
  }))

  return (
    <>
      {warnings.map(w => (
        <Alert severity="warning">
          <AlertTitle>{w.title}</AlertTitle>
          {w.description}
        </Alert>
      ))}
    </>
  )
}

export default FeeFooter
